import React from 'react'
import {Link} from 'react-router-dom'
import './CollectorsRowData.css'

function CollectorsRowData({ Collector,CollectorThumb, WorksCollected, WorksOwned, AvgPurchasePrice, TotalPurchases, BiggestPurchase }) {
    return (
        <tr className="tableSingleRow">
            <td>
                <img src={ CollectorThumb } alt="" className="userThumb"/>
                <Link className="" to="/user/username" >{ Collector }</Link>
            </td>
            <td> { WorksCollected }</td>
            <td> { WorksOwned }</td>
            <td> ${ AvgPurchasePrice }</td>
            <td> ${ TotalPurchases }</td>
            <td> ${ BiggestPurchase }</td>
        </tr>
    )
}

export default CollectorsRowData
